import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../../component/BreadCrumbBanner";
import facilitiesAPI from "../../api/facilitiesApi";

const CCTV = () => {
  const [cctv, setCctv] = useState(null);

  useEffect(() => {
    fetchCctv();
  }, []);

  const fetchCctv = async () => {
    const res = await facilitiesAPI.cctv_surveillance();

    if (res.code === 200) {
      const result = res.data;
      setCctv(result);
    }
  };
  const cctvData = cctv?.["cctv-surveillance"]?.[0];
  return (
    <>
      {/* BreadCrump Section */}
      <BreadCrumbBanner
        title="CCTV Surveillance"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {cctvData && (
        <section className="cctv-security-section py-5">
          <div className="container">
            <div className="row align-items-center g-5">
              {/* LEFT : IMAGE */}
              <div className="col-lg-6 animate__animated animate__fadeInLeft">
                <div className="cctv-image-wrapper">
                  <img
                    src={cctvData?.image}
                    alt="CCTV Surveillance"
                    loading="lazy"
                  />
                </div>
              </div>
              {/* RIGHT : CONTENT */}
              <div className="col-lg-6 animate__animated animate__fadeInRight">
                <span className="mrv-subtitle">{cctvData?.subtitle}</span>
                <h2 className="mrv-title">
                 {cctvData?.title}
                </h2>
                <p className="cctv-desc">
                   <div dangerouslySetInnerHTML={{
                      __html: cctvData?.shortdescription || "",
                    }}/>
                </p>
               
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default CCTV;
